import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'DisplayFailedList',
  props: {
    tripIdList: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tripIdList, (tripId, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: index,
      class: "trip-item"
    }, _toDisplayString(tripId), 1))
  }), 128))
}
}

})